export const DOWNLOAD_SUCCESS = 'Файл скачан';
export const DOWNLOAD_ERROR = 'Ошибка скачивания файла';
